import Hero from "./components/Hero";
import StatsBar from "./components/StatsBar";
import FeaturedCategories from "./components/FeaturedCategories";
import CategoryGrid from "./components/CategoryGrid";
import CTASection from "./components/CTASection";
import Testimonials from "./components/Testimonials";
import ArticleIndex from "./components/ArticleIndex";
import Footer from "./components/Footer";
import JsonLd from "@/components/base/JsonLd";
import { homepageSchema } from "@/utils/schemas";

export default function Home() {
  return (
    <>
      <JsonLd schema={homepageSchema} />
      <main>
        <Hero />
        <StatsBar />
        <FeaturedCategories />
        <CategoryGrid />
        <CTASection />
        <Testimonials />
        <ArticleIndex />
        <Footer />
      </main>
    </>
  );
}